<template>
  <div style="height: 100%; position: absolute; width: 100%">
    <div class="fd-nav-content">
      <section class="dingflow-design">
        <!-- 放大缩小 -->
        <div class="zoom">
          <div
            :class="'zoom-out' + (nowVal == 50 ? ' disabled' : '')"
            @click="zoomSize(1)"
          ></div>
          <span>{{ nowVal }}%</span>
          <div
            :class="'zoom-in' + (nowVal == 300 ? ' disabled' : '')"
            @click="zoomSize(2)"
          ></div>
        </div>
        <div
          class="box-scale"
          id="box-scale"
          :style="
            'transform: scale(' +
              nowVal / 100 +
              '); transform-origin: 50% 0px 0px;'
          "
        >
          <nodeWrap :nodeConfig.sync="nodeConfig"></nodeWrap>
          <div class="end-node">
            <div class="end-node-circle"></div>
            <div class="end-node-text">流程结束</div>
          </div>
        </div>
      </section>
    </div>
    <errorDialog :visible.sync="tipVisible" :list="tipList" />
    <promoterDrawer />
    <approverDrawer :directorMaxLevel="directorMaxLevel" />
    <copyerDrawer />
    <conditionDrawer />
    <transactorDrawer />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import nodeWrap from './components/nodeWrap.vue';
import errorDialog from './components/dialog/errorDialog';
import promoterDrawer from './components/drawer/promoterDrawer';
import approverDrawer from './components/drawer/approverDrawer';
import copyerDrawer from './components/drawer/copyerDrawer';
import conditionDrawer from './components/drawer/conditionDrawer';
import transactorDrawer from './components/drawer/transactorDrawer';
import preload from './plugins/preload';
export default {
  props: {
    permisionOption: {
      type: Array,
      default: () => []
    }
  },
  components: {
    nodeWrap,
    errorDialog,
    promoterDrawer,
    approverDrawer,
    copyerDrawer,
    conditionDrawer,
    transactorDrawer
  },
  data() {
    return {
      tipList: [],
      tipVisible: false,
      nowVal: 100,
      processConfig: {},
      nodeConfig: {},
      workFlowDef: {},
      flowPermission: [],
      directorMaxLevel: 0,
      hasRepeatCondition: false
    };
  },
  computed: {
    ...mapState('workflow', ['permissionOption'])
  },
  created() {},
  methods: {
    ...mapMutations('workflow', [
      'setTableId',
      'setIsTried',
      'setPermissionOption',
      'setPromoterOptions'
    ]),
    toReturn() {
      // window.location.href = ""
    },
    reErr({ child, nodeType, error, nodeName }) {
      if (nodeType == 0) {
        if (error) {
          this.tipList.push({ name: nodeName, type: '发起人' });
        }
      }
      if (child) {
        const { nodeType, error, nodeName, branchList } = child;
        if ([1, 2, 3].includes(nodeType)) {
          if (error) {
            this.tipList.push({
              name: nodeName,
              type: ['', '审核人', '抄送人', '办理人'][nodeType]
            });
          }
          this.reErr(child);
        } else if (nodeType == 4) {
          this.reErr(child);
        } else if (nodeType == 5) {
          this.reErr(child);
          // 校验是有重复名称
          this.hasRepeatCondition = preload.checkRepeatCondition(child);
          for (let i = 0; i < branchList.length; i++) {
            if (branchList[i].error) {
              this.tipList.push({
                name: branchList[i].nodeName,
                type: '条件'
              });
            }
            this.reErr(branchList[i]);
          }
        }
      } else {
        child = null;
      }
    },
    getSubmitData() {
      this.setIsTried(true);
      this.tipList = [];
      this.reErr(this.nodeConfig);
      if (this.hasRepeatCondition) {
        // 如果有重复的话，就直接不走下面的逻辑了，提示一下
        this.$Message.error('条件名称不能重复');
        return;
      }
      if (this.tipList.length != 0) {
        this.tipVisible = true;
        return;
      }
      return this.nodeConfig;
    },
    zoomSize(type) {
      if (type == 1) {
        if (this.nowVal == 50) return;
        this.nowVal -= 10;
      } else {
        if (this.nowVal == 300) return;
        this.nowVal += 10;
      }
    },
    setInitData(data) {
      let nodeConfig = data;
      if (typeof data == 'string') {
        nodeConfig = JSON.parse(data);
      }
      this.nodeConfig = nodeConfig;
    },
    getPermissionOptionStyle(data) {
      let result = [];
      data.forEach(item => {
        if (item.type == 'table' || item.type == 'grid') {
          const labelName =
            item.type == 'table'
              ? item.label
                ? `${item.label}.`
                : item.label || ''
              : item.label || '';
          if (item.child && item.child.length > 0) {
            const mapChild = item.child.map(chil => {
              const { label, ...rest } = chil;
              return {
                ...rest,
                label: labelName + label
              };
            });
            result = result.concat(mapChild);
          }
        } else {
          result.push(item);
        }
      });
      return result;
    },
    getPermissionOption() {
      return this.permissionOption || [];
    },
    editSetPermissionOption(data) {
      this.setPermissionOption(data);
    }
    // 留用设置条件选择发起人时选择下拉框 setPromoterSelect
    // setPromoterSelect(data) {
    //   this.setPromoterOptions = data;
    //   console.log('data', data);
    // }
  },
  watch: {
    permisionOption(val) {
      const delwithOptions = this.getPermissionOptionStyle(val);
      this.setPermissionOption(delwithOptions);
    }
  }
};
</script>
<style>
@import '../../assets/styles/common/workflow.css';

.error-modal-list {
  width: 455px;
}
</style>
